import R from 'ramda'

const HASHTAG_TRIGGER_TYPE = 'HASHTAG'
const HASHTAG_DISPLAY_TYPE = 'Match hashtag'

const isHashtagWidgetTrigger = R.propEq('type', HASHTAG_TRIGGER_TYPE)

const convertHashtagWidgetTriggerToFormTrigger = R.applySpec({
  type: R.always(HASHTAG_DISPLAY_TYPE),
  value: R.prop('data')
})

export { isHashtagWidgetTrigger, convertHashtagWidgetTriggerToFormTrigger }



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/triggers/twitter/widget-to-form/hashtag.js